import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Globe, Building2, Layers } from "lucide-react";

const iconMap = { Globe, Building2, Layers };

export default function Network() {
  const network = useContent().network;
  return (
    <section className="py-20 lg:py-28 bg-[#faf8f4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="reveal">
            <div className="relative rounded-2xl overflow-hidden">
              <img src={network.image} alt="Bankennetzwerk" className="w-full h-[440px] object-cover" />
              <div className="absolute bottom-5 left-5 bg-white/95 backdrop-blur rounded-xl px-6 py-4">
                <div className="font-serif-lux text-4xl text-[#16233d] leading-none">50+</div>
                <div className="text-xs text-[#5c6577] mt-1">{network.overlay1}<br/>{network.overlay2}</div>
              </div>
            </div>
          </div>

          <div className="reveal">
            <div className="eyebrow mb-4">{network.eyebrow}</div>
            <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold leading-tight">
              {network.title}
            </h2>
            <p className="mt-5 text-[#5c6577] text-lg leading-relaxed">{network.text}</p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#konditionen" className="btn-gold rounded-md px-6 py-3 font-medium">{network.btnDiscover}</a>
              <a href="#konditionen" className="btn-outline-navy rounded-md px-6 py-3 font-medium">{network.btnCompare}</a>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {network.cards.map((c) => {
            const Icon = iconMap[c.icon];
            return (
              <div key={c.title} className="card-lift bg-white rounded-xl border border-[#efe9dd] p-7">
                <div className="w-12 h-12 rounded-lg bg-[#faf3e8] flex items-center justify-center mb-5">
                  <Icon size={22} className="text-[#b08d57]" />
                </div>
                <h3 className="font-serif-lux text-2xl text-[#16233d] mb-2">{c.title}</h3>
                <p className="text-[#5c6577] text-sm leading-relaxed">{c.text}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="eyebrow mb-6">{network.flagsLabel}</div>
          <div className="flex flex-wrap justify-center items-center gap-4">
            {network.flags.map((f) => (
              <img
                key={f.code}
                src={`https://flagcdn.com/w80/${f.code}.png`}
                alt={f.name}
                title={f.name}
                className="h-7 w-auto rounded-sm shadow-sm grayscale hover:grayscale-0 transition-all duration-300"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
